// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3pf7x","text":"SelectPayment_text__1yUsQ","title":"SelectPayment_title__1ZKk8","btn":"SelectPayment_btn__27YYW"};